<template lang="pug">
    extends ../base/base.pug
    block input
        b-row
            b-col(md)
                label(
                    v-bind:for="slug + multi_field_num"
                )
                    = '{{ question }}'
                    span(
                        v-if="is_required"
                        class="requiredField"
                    ) *
            b-col(md)
                b-form-input(
                    v-model="local_answer"
                    :id="slug + multi_field_num"
                    type="text"
                    :placeholder="placeholder"
                    @change="process_change()"
                    :required="is_required"
                    :state="get_state"
                )
                b-form-invalid-feedback
                    = '{{ error_message }}'
                b-form-text
                    = '{{ helper }}'
</template>
<script>
import Base from "../base";

export default {
	extends: Base,
	props: ["placeholder"]
};
</script>
